import { createGlobalStyle } from 'styled-components/macro'
import { mq } from './mq'
import { theme } from './theme'

export const GlobalStyle = createGlobalStyle`
:root {
  --container-spacing: 2rem;
  --header-height: 8rem;
  --text-color: #1A3948;
  --background: radial-gradient(farthest-side, rgba(137, 165, 178, 0.3), rgba(22, 47, 59, 0.3));
  --col-width: 28.5rem;
  --gap: 2rem;
  --container-width: calc(4 * var(--col-width) + 3 * var(--gap));
}

${mq.medium} {
  :root {
    --container-spacing: 4rem;
    --header-height: 8.4rem;
  }
}

html {
  height: 100%;
  font-size: 62.5%;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: ${theme.fonts.base},
    sans-serif;
  min-height: 100%;
  width: 100%;
  font-size: 1.6rem;
  font-smooth: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;
  -webkit-tap-highlight-color: transparent;
  color: var(--text-color);
  background: var(--background);
  background-attachment: fixed;
  &.white {
  background: rgba(185, 204, 204, 0.05);
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}

html.locked {
  &, body {
    overflow: hidden;
  }
}

#root {
  display: contents;

  > * {
    flex-shrink: 0;
  }
}

a, a:hover, a:visited {
  color: inherit;
}

h1, h2, h3, h4, h5 {
  font-family: inherit;
}
`
